import { testimonials } from '@/mocks/comics';

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
              用户口碑
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            漫迷们的真实评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            超过580万用户的选择，听听他们怎么说
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              className={`bg-background-50 rounded-2xl p-6 ${
                i === testimonials.length - 1 ? 'opacity-50' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${s < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                  </div>
                ))}
              </div>

              {/* Title */}
              <h4 className="text-base font-semibold text-foreground-900 mb-2">
                {t.content.slice(0, 20)}...
              </h4>

              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}